import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "us.collection.creditor/services";
import * as Actions from "us.collection.creditor/actions";
import { SelectedCreditor } from "us.collection.creditor/constants/Actions/SelectedCreditors";
import { creditorGroup } from "us.collection.admin/actions";
import { $MessageBox } from "us.common/components";

const { selectedCreditors } = Actions;

const selectedCreditorsSagas = {
  saveCreditorAuthInfo: function* (action: any) {
    const params = action.payload.data;
    try {
      const { data, status } = yield call(
        API.selectCreditors.saveAuthorizedInformation,
        params
      );
      if (status == 200 || status == 201) {
        params.creditorGroupData.creditorAuthorizedInformation =
          params.payload.creditorAuthorizedInformation;
        yield put(
          selectedCreditors.creditorAuthorizedInformation.success(data)
        );

        $MessageBox(
          "success",
          `US.COLLECTION.CREDITOR:CREDITOR_INFO.CREDITOR_AUTHORIZED_INFO_CREATED_SUCCESSFULLY`,
          "",
          ""
        );
      } else {
        yield put(selectedCreditors.creditorAuthorizedInformation.fail([]));
        $MessageBox(
          "error",
          `US.COLLECTION.CREDITOR:CREDITOR_INFO.CREDITOR_AUTHORIZED_INFO_CREATED_FAILED`,
          "",
          ""
        );
      }
    } catch (error) {
      yield put(selectedCreditors.creditorAuthorizedInformation.fail([]));
      $MessageBox(
        "error",
        `US.COLLECTION.CREDITOR:CREDITOR_INFO.CREDITOR_AUTHORIZED_INFO_CREATED_FAILED`,
        "",
        ""
      );
    }
  },
};

export default [
  takeLatest(
    SelectedCreditor.ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION,
    selectedCreditorsSagas.saveCreditorAuthInfo
  ),
];
